import { DeviceState } from '../../stores/TelematicsDevice/DeviceStateApi';

export const HiltiCustomConfigurationKey = {
  SERVICE_VAN: 'hiltiServiceVan',
  HEAVY_MACHINE: 'hiltiHeavyMachine',
} as const;
export type HiltiCustomConfigurationKey =
  (typeof HiltiCustomConfigurationKey)[keyof typeof HiltiCustomConfigurationKey];

export const HiltiCustomConfigurationName = {
  SERVICE_VAN: 'setup-hilti-service-van',
  HEAVY_MACHINE: 'setup-hilti-ble-scanning',
} as const;

export type CustomConfigurationStatus = {
  configured: boolean;
  pending: boolean;
};

export function getCustomConfigurationStatus(
  state: DeviceState | undefined,
  key: string
): CustomConfigurationStatus {
  const reportedPresent = state?.reported?.customConfigurations?.[key] !== undefined;
  const desiredPresent = state?.desired?.customConfigurations?.[key] !== undefined;

  return {
    configured: reportedPresent && desiredPresent,
    pending: desiredPresent && !reportedPresent,
  };
}
